import {ComponentTypes} from "../types";
import {three as threeTypes} from "../../../types";
import {createGumball} from "../gumball";
import {Param_Mesh, ParamTitles} from "../../parameter";
import {Calc} from "../../calc";
import {WompMesh} from "../../../WompObject";
import {getMeshDataFromThreeGeometry} from "../../../converter";
import {mat4, vec3} from "gl-matrix";
import {BasicMeshGenerator} from "./basic-gen";

export class ThreeCubeGenerator extends BasicMeshGenerator {
  static defaultParameter = {
    width: 20,
    height: 20,
    depth: 20
  };
  static draggingPreview = ThreeCubeGenerator.generateMesh();

  static create() {
    let calc = createGumball();
    calc.component = ComponentTypes.ThreeCubeGenerator;
    calc.title = 'cube';

    let cubeParam = Param_Mesh.create(calc, ParamTitles.Cube, false, false, true);

    calc.addParameter(cubeParam);

    return calc;
  }

  static getDesc(calc: Calc) {
    return 'cube';
  }

  static generateMesh(parameter: any = this.defaultParameter) {
    let value: threeTypes.BufferGeometry = new threeTypes.BoxBufferGeometry(
      this.defaultParameter.width,
      this.defaultParameter.depth,
      this.defaultParameter.height
    );

    let geom = getMeshDataFromThreeGeometry(value);

    return new WompMesh(geom, this.generateMatrix(parameter));
  }

  static generateMatrix(parameter: any = this.defaultParameter) {
    return mat4.fromScaling(
      mat4.create(),
      vec3.fromValues(
        parameter.width / this.defaultParameter.width,
        parameter.depth / this.defaultParameter.depth,
        parameter.height / this.defaultParameter.height
      )
    );
  }
}
